import { Route, Routes as RoutesContainer } from "react-router";
import { User, Role } from "../index";

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/user' element={<User />} />
      <Route exact path='/user/:id/role' element={<Role />} />
    </RoutesContainer>
  );
};
export default Routes;
